'use client';

import { Button, ButtonProps } from '@mui/material';
import { HyperLink } from './HyperLink';
import { Grid2 } from '@/primitives';

export function StatusCell({
  label,
  ...rest
}: { label: string } & ButtonProps) {
  return (
    <Button color="success" disableRipple {...rest}>
      {label}
    </Button>
  );
}

type TProps = {
  name: string;
  path?: string;
  active?: boolean;
};
function NameCell({ name, path, active }: TProps) {
  return (
    <Grid2 container justifyContent={'space-between'}>
      <Grid2>
        <HyperLink label={!!name ? name : '--'} pathname={path ?? ''} />
      </Grid2>
      <Grid2>
        {active && (
          <StatusCell
            label="active"
            sx={{
              backgroundColor: 'rgba(16, 185, 129, 0.04)',
              right: 'auto',
            }}
          />
        )}
      </Grid2>
    </Grid2>
  );
}

export default NameCell;
